var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileApp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 96,
  viewBox: "0 0 120 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mobileApp_svg__filter0_ddi_4438_2795)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M87.7498 48.255L60.3198 20.345C58.7898 18.785 56.7698 17.995 54.7898 17.995C54.4898 17.995 54.1898 18.015 53.8898 18.045C52.4098 18.225 50.9998 18.865 49.8698 19.955L32.0798 37.325C29.2398 40.095 29.3198 44.765 32.2498 47.745L59.6798 75.655C61.2098 77.215 63.2298 78.005 65.2098 78.005C65.5098 78.005 65.8098 77.985 66.1098 77.955C67.5898 77.775 68.9998 77.135 70.1298 76.045L87.9198 58.685C90.7598 55.915 90.6798 51.245 87.7498 48.265V48.255ZM84.4198 55.095L66.6298 72.455C66.3298 72.755 65.9398 72.925 65.4898 72.985C65.3998 72.995 65.2998 73.005 65.1998 73.005C64.4798 73.005 63.7698 72.695 63.2298 72.145L35.8098 44.235C35.0998 43.505 34.9998 42.715 34.9998 42.305C34.9998 41.915 35.1098 41.345 35.5698 40.895L53.3598 23.545C53.6598 23.245 54.0498 23.075 54.4998 23.015C54.5898 23.005 54.6898 22.995 54.7898 22.995C55.5098 22.995 56.2198 23.305 56.7598 23.855L84.1898 51.765C84.8998 52.495 84.9998 53.285 84.9998 53.695C84.9998 54.085 84.8898 54.655 84.4298 55.105L84.4198 55.095ZM65.8198 40.665V49.025C65.8198 51.675 63.6598 53.835 61.0098 53.835H52.6498C51.2698 53.835 50.1498 52.715 50.1498 51.335C50.1498 49.955 51.2698 48.835 52.6498 48.835H60.8198V40.665C60.8198 39.285 61.9398 38.165 63.3198 38.165C64.6998 38.165 65.8198 39.285 65.8198 40.665ZM51.8998 44.715H43.5398C42.1598 44.715 41.0398 43.595 41.0398 42.215C41.0398 40.835 42.1598 39.715 43.5398 39.715H51.7098V31.545C51.7098 30.165 52.8298 29.045 54.2098 29.045C55.5898 29.045 56.7098 30.165 56.7098 31.545V39.905C56.7098 42.555 54.5498 44.715 51.8998 44.715Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "mobileApp_svg__filter0_ddi_4438_2795",
  x: 0,
  y: -12.005,
  width: 120,
  height: 120.01,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2795"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2795",
  result: "effect2_dropShadow_4438_2795"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2795",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2795"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobileApp_svg__yellow",
  x1: 30.001,
  y1: 17.995,
  x2: 85.4615,
  y2: 84.3004,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobileApp_svg__gray",
  x1: 30.001,
  y1: 17.995,
  x2: 85.4615,
  y2: 84.3004,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgMobileApp as ReactComponent };
export default __webpack_public_path__ + "assets/icons/mobileApp.f88542.svg";